import {TopNavBarStateType} from 'module/TopNavBar/reducer/TopNavBarReducer'
import {createSelector} from 'reselect'
import _ from 'lodash'

export const selTopNavBarTitle = (state: TopNavBarStateType) => state.TopNavBar.title
export const selTopNavBarButtons = createSelector(
	(state: TopNavBarStateType) => state.TopNavBar.buttons,
	(btn) => _.sortBy(_.values(btn).filter(x => x.visible), 'nr'),
)
